import axios from "axios";
import {urlAzure,url} from "../config";

  
  export async function getProjects(setProjects,token) {
    try {
      const response = await axios.get(`${url}apiProduccion/Proxy/getProjects`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
  
      setProjects(response.data);
    } catch (error) {
      console.error("Error obteniendo proyectos:", error);
    }
  }
  
  export async function getStagesByProject(absEntry, token, setStages) {
    if (!absEntry) return; // Evita llamadas innecesarias si absEntry está vacío
  
    try {
      const response = await axios.get(`${url}apiProduccion/Proxy/getStageProjects?absentry=${absEntry}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
  
      setStages(response.data); // Guarda las etapas en el estado
    } catch (error) {
      console.error(`Error obteniendo etapas para el proyecto ${absEntry}:`, error);
    }
  }